<template>
  <div>
    <Breadcrumb :options="breadcrumb" />

    <TabMenu :menuIndex="menuIndex" :menu="menu" />

    <div>
      <router-view></router-view>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      breadcrumb: [
        { name: "加油站管理" },
        { name: "库存" },
      ],
      menuIndex: '',
      menu: [
        {
          name: "柴油",
          path: '/oilStation/stock/table',
        },
      ],
    };
  },
  methods: {
  },
  mounted() {
    this.menuIndex = this.$route.path
  },
};
</script>
